import React, { useCallback, useState } from "react";
import {
  View,
  TouchableOpacity,
  StyleSheet,
  FlatList,
  Platform,
  Text,
} from "react-native";

import GlobalStyles from "../../globalStyles/globalStyles";
import { Colors } from "../../globalStyles/ColorConfig";
import dimensions from "../../globalStyles/dimensions";
import CustomComponent from "../../components/CustomComponent";
import CustomModalComponent from "../CustomModalComponent";
import ExperienceIcons from "../../assets/Icons/ExperienceIcons";
import data from "../../utils/countries";

interface SelectCountryProps {
  isDialog?: boolean;
  isVisible: boolean;
  toggleModal: () => void;
  method1: any;
  method2: any;
  onSelectCountry: any;
}

const debounce = (func: Function, delay: number) => {
  let timeoutId: NodeJS.Timeout;
  return function (...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export default function SelectCountry({
  toggleModal,
  method1,
  method2,
  onSelectCountry,
}: SelectCountryProps) {
  const [searchText, setSearchText] = useState("");

  const handleSearchChange = useCallback(
    debounce((text: string) => {
      setSearchText(text);
    }, 500),
    []
  );

  const filteredCountries = data.filter(
    (item) =>
      item.name.toLowerCase().includes(searchText.toLowerCase()) ||
      item.dial_code.includes(searchText)
  );

  const Item = ({ item }: any) => {
    return (
      <TouchableOpacity
        onPress={() => onSelectCountry(item.dial_code, item.flag, item.code)}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            paddingVertical: 10,
            gap: 10,
          }}
        >
          <CustomComponent.TextView
            title={item?.name}
            textStyle={GlobalStyles.title3}
          />
          <Text style={{ fontSize: 30 }}>{item?.flag}</Text>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <CustomModalComponent
      toggleModal={toggleModal}
      width={'100%'}
      height={dimensions.windowHeight / 1.5}
    >
      <View style={styles.countryContainer}>
        <View style={styles.countryHeader}>
          <CustomComponent.TextView
            title="Select country code"
            textStyle={GlobalStyles.heading3}
          />
          <TouchableOpacity onPress={method2}>
            <ExperienceIcons.Cross />
          </TouchableOpacity>
        </View>
        <View style={{width: '100%', height: 50, marginVertical:10}}>
          <CustomComponent.InputField
            placeholder="Search by name or dial code"
            onTextChange={handleSearchChange}
            keyboardtype="default"
          />
        </View>
        <FlatList
          data={filteredCountries}
          keyExtractor={(item) => item?.name}
          renderItem={({ item }) => <Item item={item} />}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{
            paddingBottom:
              Platform.OS === "web" ? 30 : dimensions.paddingVertical * 5,
          }}
          keyboardShouldPersistTaps="handled"
        />
      </View>
    </CustomModalComponent>
  );
}
const styles = StyleSheet.create({
  countryContainer: {
    flex: 1,
    backgroundColor: Colors.white000,
    paddingHorizontal: Platform.OS === "web" ? 20 : dimensions.paddingHorizontal
  },
  countryHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingTop: dimensions.paddingVertical,
  },
});
